export { default } from '@shikijs/langs/perl'
